/**
 * 对象是否为空
 */
export function isEmptyObj(obj) {
  // 判断对象是否是 null 或者不是对象
  if (typeof obj !== 'object' || obj === null) {
    return true
  }
  // 使用 Object.keys() 获取对象的所有键并判断是否为空
  return Object.keys(obj).length === 0
}

/**
 * 递归地排序一个 对象的键（key），并返回一个新的对象，其中的键按字母顺序排序。对于对象的嵌套属性，也会递归地进行排序，数组则保持不变
 */

export function sortJsonKeys(obj) {
  if (obj && typeof obj === 'object') {
    const sortedObj = Array.isArray(obj) ? [...obj] : {} // 若是数组，保留数组结构
    const keys = Object.keys(obj).sort() // 对键进行排序

    for (const key of keys) {
      sortedObj[key] = sortJsonKeys(obj[key]) // 递归排序值
    }
    return sortedObj
  }
  return obj // 不是对象或数组时直接返回原始值
}
